import * as yup from 'yup';
import { GladlyFaqList } from '@web/components/GladlyFaqList';
import { requiredImageFromCMSSchema } from '../schemas';

export const component = GladlyFaqList;

export const contactMethodSchema = yup
  .object({
    title: yup.string(),
    text: yup.string(),
    path: yup.string(),
    icon: requiredImageFromCMSSchema,
  })
  .transform(value => ({
    title: value.title,
    text: value.text,
    path: value.path,
    icon: value.icon,
  }));

export const schema = yup
  .object({
    eyebrow: yup.string().required(),
    heading: yup.string().required(),
    contactHeading: yup.string().required(),
    subheading: yup.string(),
    backgroundColor: yup.string(),
    contactMethods: yup.array(contactMethodSchema).required(),
  })
  .transform(value => ({
    eyebrow: value.eyebrow,
    heading: value.heading,
    contactHeading: value.contact_heading,
    backgroundColor: value.background_color || undefined,
    contactMethods: value.contact_methods,
  }));
